export enum ImportType {
  SAFT = 'SAF-T',
 manual = 'Manual',
}
